import {MenuItem} from "../../../lib/phinxapp/profiles/types";
import {mainMenu} from "./Main";

export const routes: MenuItem[] = [mainMenu];
